import styled from '@emotion/styled';
import { gsap } from 'gsap';
import { useState, useLayoutEffect, useRef } from 'react';

import { animateSVGPath } from '@components/Sections/utils/animations';
import { PenLine } from '@features';
import { getMediaqueryStyled } from '@styles/mixins/mediaqueries';

export const TitlePenOutline: React.FC = () => {
  const [titlePenOutlinePathLength, setTitlePenOutlinePathLength] = useState(0);
  const titlePenOutlineRef = useRef<SVGPathElement | null>(null);

  useLayoutEffect(() => {
    const titlePenOutlineEl = titlePenOutlineRef.current;

    if (!titlePenOutlineEl) {
      return;
    }

    const ctx = gsap.context(() => {
      const penPathLength = titlePenOutlineEl.getTotalLength();
      setTitlePenOutlinePathLength(penPathLength);
      animateSVGPath({
        animationTarget: titlePenOutlineEl,
        animationTrigger: titlePenOutlineEl,
        animationStartPositions: 'top 30%',
        pathLength: penPathLength,
      });
    });

    return () => ctx.revert();
  }, []);

  return (
    <PenOutline
      isFullCentered
      width="364"
      height="121"
      viewBox="0 0 364 121"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M57.0154 27.5372C-5.82908 7.04116 -2.30904 59.0795 4.66557 79.2479C23.9495 127.526 126.785 119.5 189.809 119.5C286.662 112.609 369.149 113.952 362.639 58.0922C347.474 -31.1802 88.0478 8.66883 53.9642 17.4469C28.6518 23.9659 12.7691 36.6217 10.9638 41.0961"
        stroke="#D9FC51"
        strokeWidth="2"
        strokeLinecap="round"
        vectorEffect="non-scaling-stroke"
        strokeDasharray={`${titlePenOutlinePathLength} ${titlePenOutlinePathLength}`}
        ref={titlePenOutlineRef}
      />
    </PenOutline>
  );
};

const PenOutline = styled(PenLine)`
  top: 40%;
  width: 339px;

  ${getMediaqueryStyled('xl')} {
    width: 264px;
  }

  ${getMediaqueryStyled('lg')} {
    width: 168px;
  }

  ${getMediaqueryStyled('sm')} {
    left: 52%;
    top: 46%;
    width: 163px;
  }
`;
